import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from "react-router-dom";
import { ROLE } from "../../config/index";
import route from "../../config/routes";
import ScreenLoad from "../layout/ScreenLoad"

class ProtectRoute extends Component {
  constructor(props){
    super(props);
    this.state = {
      loading: true
    }
  }

  setLoading = () => {
    this.setState({ loading: false });  
  }

  componentDidMount() {
    if (Array.isArray(this.props.profile) && this.props.profile.length < 1) {
      var timesRun = 0;
      var interval = setInterval(() => {
        if (timesRun === 15) {
          this.setLoading();
          clearInterval(interval);
        }
        if (!Array.isArray(this.props.profile) && Object.keys(this.props.profile).length > 0) {
          this.setLoading();
          clearInterval(interval);
        }
        timesRun += 1;
      }, 1000);
    } else {
      this.setLoading();
    }
  }
  
  render(){
    const { rightsNeeded, component: Component, profile } = this.props,
      [path, access] = rightsNeeded,
      role_access = Object.keys(profile).length > 0 ? JSON.parse(profile.role_access) : {};
    
    if (this.state.loading) {
      return (
        <ScreenLoad title={this.props.location.pathname} />
      );
    }
    return (
      <Route
        render={(props) =>
          Object.keys(role_access).length > 0 && role_access.role === ROLE.ADMIN.toLowerCase() ? (
            <Component {...this.props} />
          ) : (
            Object.keys(role_access).length > 0 && role_access.role === ROLE.SUB_ADMIN.toLowerCase() && role_access.access[path] && role_access.access[path][access] ? (
              <Component {...this.props} />
            ) : (
              <Redirect to={{ pathname: route.DASHBOARD, state: { from: props.location } }} />
            )
          )
        }
      />
    )}
}

const mapStateToProps = state => ({
  profile: state.profile
})

export default connect(mapStateToProps, null)(ProtectRoute)